/*jslint regexp: true */
define(['jquery', 'c21', 'jquerycookie'], function ($, c21) {
   "use strict";

   var m_strPrefix = "c21eco.",

      m_strDomain,

      getDomain = function () {
         if (m_strDomain === undefined) {
            //m_strDomain = window.cookieDomain || '.' + location.hostname.split('.').slice(1).join('.');
            m_strDomain = window.cookieDomain || location.hostname;
         }

         return m_strDomain;
      },

      getDateAfterSeconds = function (iSeconds) {
         var dt = new Date();
         dt.setTime(dt.getTime() + (iSeconds * 1000));
         return dt;
      },

      setRawCookie = function (strKey, strValue, strPath, iExpireSeconds, bWildcardDomain) {
         var options = {
               domain: (bWildcardDomain) ? getDomain() : undefined,
               expires: (iExpireSeconds) ? getDateAfterSeconds(iExpireSeconds) : undefined,
               path: strPath
            };

         $.cookie(strKey, strValue, options);
      },

      setCookie = function (strKey, strValue) {
         setRawCookie(m_strPrefix + strKey, strValue, "/", 7 * 24 * 60 * 60, true);
      },

      getCookie = function (strKey) {
         var strCookie = $.cookie(m_strPrefix + strKey) || null;
         return strCookie ? decodeURIComponent(strCookie) : null;
      },

      removeCookie = function (strKey) {
         var strName = m_strPrefix + strKey,
            options = {
               domain: getDomain(),
               path: "/",
               expires: "Thu, 01-Jan-1970 00:00:01 GMT"
            };

         $.cookie(strName, null, options);
      },

      initialize = function () {
         var strCookie = getCookie("visited");

         // Set visited cookie for session authorization
         if (strCookie === null || strCookie.length === 0) {
            setCookie("visited", new Date());
         }
      };

   initialize();

   return {
      /**
       * Create new cookie: Set the cookie key and value
       * @param {string} strKey
       * @param {string} strValue
       */
      set: setCookie,

      /**
       * Get the cookie by its key
       * @param {string} strKey
       * @return {string}
       */
      get: getCookie,

      /**
       * Delete the cookie by its key
       * @param {string} strKey
       */
      remove: removeCookie,

      /**
       * Get the search cookie search results link
       * @param {string} strSearch
       */
      generateSearchCookieLink: function (strSearch) {
         var strCookie = null,
            strSearchType = strSearch || null;

         if (strSearchType === null || $.trim(strSearchType).length <= 0) {
            strCookie = getCookie("LAST_SEARCH");
         } else {
            strCookie = getCookie("LAST_" + strSearchType);
            if (strCookie === null || strCookie === "null" || $.trim(strCookie).length <= 0) {
               strCookie = getCookie("LAST_SEARCH");
            }
         }

         if (strCookie === null || strCookie === "null" || $.trim(strCookie).length <= 0) {
            return null;
         }

         strCookie = strCookie.replace(/__CANONICAL=[^&]+(&|$)/, "");
         strCookie = strCookie.replace(/SUBVIEW=[^&]+(&|$)/, "");

         //This is a handoff link
         if (strCookie.indexOf('__HANDOFF') !== -1) {
            strCookie = strCookie.replace("__HANDOFF=1", "");
            return strCookie;
         }

         var url = "/search.c21?" + strCookie,
            newUrl = "/search.c21?",
            oParams = {},
            iCount = 1,
            strQuery = url.split("?")[1],
            oQuery = c21.queryToJSON(strQuery);

         $.each(oQuery, function (strKey, strValue) {
            oParams[strKey.toLowerCase()] = strValue;
            if (iCount === 1) {
               newUrl = newUrl + strKey.toLowerCase() + "=" + strValue;
            } else {
               newUrl = newUrl + "&" + strKey.toLowerCase() + "=" + strValue;
            }
            iCount++;
         });

         return newUrl;
      }
   };
});
